"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpEvent = void 0;
const abstract_event_1 = require("../abstract.event");
class SignUpEvent extends abstract_event_1.AbstractEvent {
    constructor(config) {
        super(config);
        this.config = config;
        this.name = 'sign_up';
    }
    getData() {
        return {
            method: this.config.method,
            firstname: this.config.firstname,
            lastname: this.config.lastname,
            email: this.config.email,
            id: this.config.id,
            shop_id: this.config.shop_id,
            user_id: this.config.user_id,
            client_id: this.config.client_id,
            allow_marketing: this.config.allow_marketing,
            allow_sms_marketing: this.config.allow_sms_marketing,
        };
    }
}
exports.SignUpEvent = SignUpEvent;
//# sourceMappingURL=sign-up.event.js.map